import {EventBus} from "../../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import {MitulaSerpPageData} from "../SerpPage";

function init(pageData: MitulaSerpPageData) {
    eventHandlers.init(EventBus.getInstance(), pageData);
}

export default {
    init,
};
